import React from 'react';

const AnchorSVG = ({ className = '' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 40 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="7" r="5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <circle cx="20" cy="7" r="2" fill="currentColor"/>
    <line x1="4" y1="14" x2="36" y2="14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="20" y1="12" x2="20" y2="40" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M20 40 C13 38 5 33 5 26" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
    <path d="M20 40 C27 38 35 33 35 26" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
    <path d="M5 26 C5 46 35 46 35 26" stroke="currentColor" strokeWidth="1.5" fill="none"/>
  </svg>
);

const Registry: React.FC = () => (
  <main>
    {/* PAGE HEADER */}
    <div className="page-header">
      <AnchorSVG className="page-header__anchor" />
      <p className="page-header__eyebrow">Gifts &amp; Giving</p>
      <h1 className="page-header__title">Registry</h1>
      <div className="page-header__rule page-rule">
        <div className="rule-line rule-line--short"></div>
        <div className="rule-diamond"></div>
        <div className="rule-line rule-line--short"></div>
      </div>
    </div>

    {/* CARD */}
    <section className="registry-section">
      <div className="registry-card">
        <h2 className="registry-card__heading">Your presence is the present</h2>
        <p className="registry-card__sub">Cash Funds</p>

        <div className="registry-card__divider page-rule">
          <div className="rule-line rule-line--short"></div>
          <div className="rule-diamond"></div>
          <div className="rule-line rule-line--short"></div>
        </div>

        <p className="registry-card__body">
          Your presence at the wedding is truly enough of a gift! But for those of you who'd like to
          contribute more, there are a few options. Since Ashley and A.J. will be traveling
          for Ashley's career, they won't be asking for items — instead, they have put together some
          cash funds you can pick from.
        </p>

        <a
          href="https://withjoy.com/ecmf1svvs/registry"
          target="_blank"
          rel="noopener noreferrer"
          className="cta-button"
        >
          View Registry
        </a>
      </div>
    </section>
  </main>
);

export default Registry;
